import { DEFAULT_RIBBON_HALFTONE_MATERIAL, SUBTLE_RIBBON_INTERACTION } from "../interaction";
import { DEFAULT_RIBBON_FRAMING_HEIGHT, LANDING_ENDCAP_ZOOM, LINE_SPACING, MATCHED_IDLE_SPEED, PAPER, REVEAL_SPACING, STANDARD_END, STANDARD_START, } from "./shared";
// The prototype authored Contact against a roughly 1050px-tall viewport. Map
// its viewport-relative centers into the shared fixed reference frame so the
// band keeps the prototype's vertical placement while shorter windows crop it.
const remapTopAnchoredCenter = (center, sourceHeight, targetHeight) => 1 - ((1 - center) * sourceHeight) / targetHeight;
const CONTACT_CENTER_Y = remapTopAnchoredCenter(0.56, 1056, DEFAULT_RIBBON_FRAMING_HEIGHT.desktop);
const CONTACT_MOBILE_CENTER_Y = remapTopAnchoredCenter(0.52, 844, DEFAULT_RIBBON_FRAMING_HEIGHT.mobile);
/** Contact (prototype CONTACT_AURORA_CONFIG): a full-bleed soft horizontal band
 * that converges through the form. */
export const CONTACT_PRESET = {
    id: "contact",
    roles: ["settle"],
    mobileBreakpoint: 900,
    palette: "primary-v2",
    shape: "line",
    halftone: DEFAULT_RIBBON_HALFTONE_MATERIAL,
    interaction: SUBTLE_RIBBON_INTERACTION,
    initialStateId: "contact-signal",
    states: [
        {
            id: "contact-signal", background: PAPER, zoom: 0.72, center: [0.5, CONTACT_CENTER_Y],
            halftoneApparentZoom: LANDING_ENDCAP_ZOOM,
            rotationDeg: 10, lineExtent: 0.72, turbulence: 0.2, spacing: REVEAL_SPACING,
            speed: MATCHED_IDLE_SPEED, dither: 1, spatialColor: 0.3, twistRetention: 0.88,
            fanSpread: 0.018, twistSpread: 0.038, horizontalStretch: 1.8, unravel: 0.64,
            curveStrength: 0.22, curveProgress: 0.15,
            mobile: { zoom: 0.5, center: [0.5, CONTACT_MOBILE_CENTER_Y], rotationDeg: 8, lineExtent: 0.72, horizontalStretch: 1.5 },
        },
        {
            id: "contact-converge", background: PAPER, zoom: 0.6, center: [0.52, CONTACT_CENTER_Y],
            halftoneApparentZoom: LANDING_ENDCAP_ZOOM,
            rotationDeg: -88, lineExtent: 0.66, turbulence: 0.07, spacing: LINE_SPACING,
            speed: MATCHED_IDLE_SPEED, dither: 1, spatialColor: 0.13, twistRetention: 0.96,
            fanSpread: 0.008, twistSpread: 0.015, horizontalStretch: 1.05, unravel: 0.14,
            funnelStrength: 0.16, funnelWidth: 0.5, funnelTurbulence: 0.12,
            funnelSpacing: LINE_SPACING, funnelLineDefinition: 1, curveStrength: 0, curveProgress: 0,
            mobile: { zoom: 0.44, lineExtent: 0.82, funnelWidth: 0.86 },
        },
    ],
    steps: [
        {
            role: "settle",
            stateId: "contact-converge",
            start: STANDARD_START,
            end: STANDARD_END,
        },
    ],
};
//# sourceMappingURL=contact.js.map